import axios from '../base/axios';
import API_KEY from './key';

const GET_TVDRAMA = 'flixfrenzy/redux/GET_TVDRAMA';

// eslint-disable-next-line default-param-last
const tvDramaReducer = (state = [], action) => {
  switch (action.type) {
    case GET_TVDRAMA:
      return action.payload;
    default:
      return state;
  }
};

export const getTvDrama = () => (dispatch) => {
  axios.get(`discover/tv?api_key=${API_KEY}&with_genres=18`).then((res) => {
    dispatch({
      type: GET_TVDRAMA,
      payload: res.data,
    });
  });
};

export default tvDramaReducer;
